import { render, staticRenderFns } from "./ScrollableDiv.vue?vue&type=template&id=54d8481c&"
import script from "./ScrollableDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollableDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Intersect,Resize})
